
import Vue from 'vue'
import AppMixin from '@/_mixins/app'
import DialogTemplate from '@/_components/dialog/template/template.vue'
import { patchAdmin } from '@/views/Authorization/utils/authorization'

const CompanyAdminPostDialog = Vue.extend({
    mixins: [AppMixin],
    components: { DialogTemplate },
    props: {
        props: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            giveAccessToAllProjects: true,
        }
    },

    computed: {
        user(): Record<string, any> {
            return this.props.user
        },
        company(): Record<string, any> {
            return this.props.company
        },
    },

    methods: {
        async patchCompanyAdmin() {
            this.loading = true

            await patchAdmin(this.user.admin, { giveAccessToAllProjects: true }).catch(() => {
                this.loading = false
            })

            this.$emit('close', this.user)
            this.loading = false
        },
    },
})

export default CompanyAdminPostDialog
